import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=214b6d50&scoped=true&"
var script = {}
import style0 from "./CancelButton.vue?vue&type=style&index=0&id=214b6d50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b6d50",
  null
  
)

export default component.exports